<template>
  <admin-wrapper :straight-title="additionalModuleName" :module-enabler="moduleEnabler" :has-buttons="false" />
</template>
<script>
import { get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'WaterNetworkDevelopmentSettings',
  components: { AdminWrapper },
  computed: {
    additionalModuleName: get('admin/additionalModules.WATER_NETWORK_DEVELOPMENT_MODULE.verbose_name'),
    moduleEnabler() {
      return {
        name: 'water_network_development_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
};
</script>
